module.exports = __webpack_public_path__ + "img/arrow-white.93be7936.svg";